import { PromotionData, TrackEventArguments } from './types';
import { trackError } from '../utils/trackError';

export const PROMOTION_MISSING_DATA_BOUNDARY = 'trackGA4Promo/missingData';
export const PROMOTION_MISSING_PROMO_ID_BOUNDARY =
  'trackGA4Promo/missingPromoId';
export const PROMOTION_DATA_ERROR_MESSAGE =
  'Cannot process promotion tracking when data object is not provided';
export const PROMOTION_ID_ERROR_MESSAGE =
  'Cannot process promotion tracking when promotion ID is not provided';

export const handlePromotionError = (data: PromotionData) => {
  if (!data) {
    trackError(
      new Error(PROMOTION_DATA_ERROR_MESSAGE),
      PROMOTION_MISSING_DATA_BOUNDARY
    );
    return;
  }
  if (!data.promo?.id) {
    trackError(
      new Error(PROMOTION_ID_ERROR_MESSAGE),
      PROMOTION_MISSING_PROMO_ID_BOUNDARY
    );
    return;
  }
};

export const EVENT_MISSING_PAGE_BOUNDARY = 'trackEvent/missingPage';

export const handleEventError = (data: Partial<TrackEventArguments>) => {
  if (!data.page) {
    const message = `Event with category: ${data.category}, action: ${data.action}, label: ${data.label} will not be tracked because page is not provided`;
    trackError(new Error(message), EVENT_MISSING_PAGE_BOUNDARY);
    return;
  }
};

export const PAGE_MISSING_PAGE_BOUNDARY = 'trackPage/missingPage';
export const PAGE_ERROR_MESSAGE =
  'Cannot process pageview/screenview tracking when page parameter is not provided';

export const handlePageError = (page: string) => {
  if (!page) {
    trackError(new Error(PAGE_ERROR_MESSAGE), PAGE_MISSING_PAGE_BOUNDARY);
    return;
  }
};

export const SURVEY_MISSING_EVENT_NAME_BOUNDARY = 'trackSurvey/missingEvent';
export const SURVEY_EVENT_ERROR_MESSAGE =
  'Cannot process survey tracking when event is not provided';

export const surveyTrackingHasErrors = (event: string) => {
  if (!event) {
    trackError(
      new Error(SURVEY_EVENT_ERROR_MESSAGE),
      SURVEY_MISSING_EVENT_NAME_BOUNDARY
    );
    return true;
  }
  return false;
};
